import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './lang'
import { Lazyload, Toast, Indicator } from 'mint-ui'
import 'assets/font/iconfont.css'
import VConsole from 'vconsole'
import { getUserInfo } from '@/utils/native'
import { getUrlParam } from '@/utils/utils'

Vue.config.productionTip = false
Vue.use(Lazyload, {
  error: require('image/error.png'),
  loading: require('image/default.png'),
  attempt: 1
})
Vue.prototype.$toast = Toast
Vue.prototype.$loading = Indicator
Vue.prototype.$uuid = require('uuid/v1')

/* eslint-disable */
// 移动端调试
if (process.env.NODE_ENV === 'development' || getUrlParam('vconsole') === '1') {
  new VConsole()
}

// 从app获取用户信息
getUserInfo().then(info => {
  if (typeof info === 'string') {
    info = JSON.parse(info)
  }
  store.commit('SET_USER_INFO', info)
})

const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

// 监听请求状态码变化
store.watch(state => state.app.apiStatus, (apiStatus) => {
  router.push('/error')
})

window.webapp = app



// WEBPACK FOOTER //
// ./src/main.js